export default "__VITE_ASSET__BtxDzzmA__"